import {ErrorLog} from '../../interfaces/core/error-log';
import {DeviceService} from '../../services/core/device.service';

export class ErrorLogFactory {
  public static fromObject(errorLog: any): ErrorLog {
    return new class implements ErrorLog {
      message: string = errorLog.message;
      name: string = errorLog.name;
      stack: string = errorLog.stack;
      version: string = errorLog.version;
      // ---------------------------------------------------------------------------------------------------------------
      id: number = errorLog.id;
      uuid: string = errorLog.uuid;
      modified: string = errorLog.modified;
      created: string = errorLog.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param errorLog
   */
  public static toRemote(errorLog: ErrorLog): any {
    return {
      message: errorLog.message,
      name: errorLog.name,
      stack: errorLog.stack,
      version: errorLog.version,
      modified: errorLog.modified,
      created: errorLog.created
    };
  }

  /**
   *
   * @param error
   */
  public static fromError(error: Error): ErrorLog {
    return new class implements ErrorLog {
      message: string = error.message;
      name: string = error.name;
      stack: string = error.stack;
      version: string = null;
      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    };
  }

}
